import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppInitializationService } from 'app/app-initialization.service';
import { Container } from 'app/models/container.model';
import { PoligonDetail } from 'app/models/poligon.model';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class ContainerService {

    container: any[];
    onChanged: BehaviorSubject<any>;

    constructor(
        private _httpClient: HttpClient,
        private appConfigService: AppInitializationService,
    ) {
        this.onChanged = new BehaviorSubject({});
    }

    getContainers(companyId: number): Promise<Array<Container>> {

        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "containers/" + companyId)
                .subscribe((response: any) => {
                    this.container = response;
                    this.onChanged.next(this.container);
                    resolve(response);
                }, reject);
        });
    }

    getByPolygonsContainer(imei: string): Promise<Array<PoligonDetail>> {

        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "containers/polygon?imei=" + imei)
                .subscribe((response: any) => {
                    this.container = response;
                    this.onChanged.next(this.container);
                    resolve(response);
                }, reject);
        });
    }

    getByDeviceContainer(deviceId: string): Promise<Container> {

        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "containers/getbydevicecontainer/" + deviceId)
                .subscribe((response: any) => {
                    this.container = response;
                    this.onChanged.next(this.container);
                    resolve(response);
                }, reject);
        });
    }


    getAllContainerDetail(companyId: number): Promise<Array<Container>> {
        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "containers/allcontainerdetail/" + companyId)
                .subscribe((response: any) => {
                    this.container = response;
                    this.onChanged.next(this.container);
                    resolve(response);
                }, reject);
        });
    }

    add(entity: Container): Promise<Container> {

        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "containers/add", entity)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }
    updated(entity: Container): Promise<Container> {

        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "containers/update", entity)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }
    delete(entity: Container): Promise<Container> {
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "containers/delete", entity)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

    multiDelete(ids: Array<number>): Promise<Container> {
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "containers/multiDelete", ids)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

}
